import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4800b242"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "l-page ha-page" }
const _hoisted_2 = { class: "ha-error l-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "ha__ttl c-ttl" }, "システムエラー", -1))
const _hoisted_4 = { class: "ha__sec ha-error__sec" }
const _hoisted_5 = { class: "p-messages" }
const _hoisted_6 = { class: "c-message" }
const _hoisted_7 = { class: "c-message__txt c-message__txt--primary" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ha__txt" }, "恐れ入りますがはじめから操作をお願いいたします。", -1))
const _hoisted_10 = {
  key: 0,
  class: "c-field has-submit has-mt"
}
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "サービスに戻る", -1))
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("section", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("span", null, "エラーが発生しました。" + _toDisplayString(_ctx.messageRef), 1)
            ])
          ])
        ]),
        _hoisted_9,
        (_ctx.siteInfo.kind === 'web')
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("a", {
                href: _ctx.siteDefaultCallbackUrl,
                class: "ha-btn"
              }, _hoisted_13, 8, _hoisted_11)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}